import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Domain\Org\Http\Controllers\AuthController::verify
* @see app/Domain/Org/Http/Controllers/AuthController.php:100
* @route '//org.launchstation.app/auth/challenge'
*/
export const verify = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verify.url(options),
    method: 'post',
})

verify.definition = {
    methods: ["post"],
    url: '//org.launchstation.app/auth/challenge',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::verify
* @see app/Domain/Org/Http/Controllers/AuthController.php:100
* @route '//org.launchstation.app/auth/challenge'
*/
verify.url = (options?: RouteQueryOptions) => {
    return verify.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::verify
* @see app/Domain/Org/Http/Controllers/AuthController.php:100
* @route '//org.launchstation.app/auth/challenge'
*/
verify.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verify.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::verify
* @see app/Domain/Org/Http/Controllers/AuthController.php:100
* @route '//org.launchstation.app/auth/challenge'
*/
const verifyForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: verify.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::verify
* @see app/Domain/Org/Http/Controllers/AuthController.php:100
* @route '//org.launchstation.app/auth/challenge'
*/
verifyForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: verify.url(options),
    method: 'post',
})

verify.form = verifyForm

const challenge = {
    verify: Object.assign(verify, verify),
}

export default challenge